module.exports = __webpack_public_path__ + "static/media/RoqueRojo.11c7e1fe.png";